<template>
    <SfSection
        v-if="block.label && block.externalUrl"
        layout="call-to-action"
    >
        <sf-button
            element="a"
            :href="block.externalUrl"
            target="_blank"
        >
            <template v-slot:pre><sf-icon icon="arrow-right" /></template>
            <template v-slot:default>{{ block.label }}</template>
        </sf-button>
    </SfSection>
</template>

<script>
import contentBlockMixin from '~/mixins/content-block';
import SfSection from '~/patterns/organisms/section/section';
import SfButton from '~/patterns/atoms/button/button';
import SfIcon from '~/patterns/atoms/icon/icon';

export default {
    components: {
        SfSection,
        SfButton,
        SfIcon
    },

    mixins: [
        contentBlockMixin
    ]
};
</script>
